import React from 'react';

/**
 * Единое написание бренда: Senti + Hype (золотой).
 * Меняются только размеры через className (например: text-lg, text-2xl, text-4xl).
 */
interface AppNameProps {
  /** Классы для размера и начертания (цвет "Senti" наследуется, "Hype" всегда gold) */
  className?: string;
}

const AppName: React.FC<AppNameProps> = ({ className = '' }) => (
  <span className={className}>
    Senti<span className="text-brand-gold">Hype</span>
  </span>
);

export default AppName;
